import React from 'react';

interface IProps {
  style?: object,
  children: React.ReactNode,
}

const FooterWrapper = ({ style, children }: IProps) => (
  <tfoot style={ style }>
    { children }
  </tfoot>
);

export default FooterWrapper;
